
import React from 'react';
import { useAdminAuth } from '@/hooks/use-admin-auth';
import { Navigate } from 'react-router-dom';
import ArchitectureOverview from '@/components/admin/architecture-overview';

export default function ArchitecturePage() {
  const { isAdmin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p>Laster arkitektur...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="h-full flex flex-col">
      <div className="border-b bg-background px-6 py-4">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl font-bold">Systemarkitektur</h1>
          <p className="text-muted-foreground">
            Oversikt over systemets komponenter, dataflyt og mappingstrukturer
          </p>
        </div>
      </div>

      <div className="flex-1 p-6">
        <div className="max-w-6xl mx-auto">
          <ArchitectureOverview />
        </div>
      </div>
    </div>
  );
}
